// details of all the replies for selected Post
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Breadcrumbs } from "@material-ui/core";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import AttachmentIcon from "@material-ui/icons/Attachment";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import PanToolIcon from "@material-ui/icons/PanTool";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import LockIcon from "@material-ui/icons/Lock";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";
import ReplyIcon from "@material-ui/icons/Reply";
import moment from "moment";
// import ImageCarousel from "../../components/internaltopic/carousel/carousel";
// import ConfirmationDialog from "../../components/common/confirmModal/confirm";
import "./TopicDetail.css";
// for quoting
import QuoteForm from "./forum_components/QuoteForm";
// import ReactHtmlParser from "react-html-parser";
import EditPost from "./forum_components/EditPost";
import ImageViewer from "./imageViewer/ImageViewer";
// for editing replies
import EditReplyForm from "./forum_components/EditReplyForm";
// import Layout from "../../components/common/Layout";
// import { apiUrl } from "../../config/config";
import MyEditor from "../../components/common/Editor"

import {
  deletePost,
  getPost,
  getPosts,
} from "../../services/posts";
import {
  deleteTopic,
  getTopic,
} from "../../services/topics";

import ReplyTopic from "./forum_components/replyTopic";

function TopicDetail(props) {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [showReplyForm, setShowReplyForm] = useState(false);

  const [replyForm, setReplyForm] = useState(false);

  const [quoteForm, setQuoteForm] = useState(false);
  const [quotePostForm, setQuotePostForm] = useState(false);
  const [quoteComment, setQuoteComment] = useState("");
  const [quoteCommentForReply, setQuoteCommentForReply] = useState("");

  const [editForm, setEditForm] = useState(false);
  const [editPost, setEditPost] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ type: "", message: "" });
  const [topicNarrative, setTopicNarrative] = useState("");

  let { topicId } = useParams();

  const [topicReply, setTopicReply] = useState(false);
  const [postReply, setPostReply] = useState(false);

  const [topic, setTopic] = useState({});
  const [replies, setReplies] = useState([]);

  const [isImageViewerOpen, setImageViewerOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  //submit edit form
  const submitForm = (e) => {
    e.preventDefault();
    setShowForm(false);
    setEditPost(false);
  };

  //SubmitForm for the topic reply
  const submitReplyForm = (e) => {
    e.preventDefault();
    setShowReplyForm(false);
    setTopicReply(false);
  };
  //SubmitForm for the Post reply
  const submitReplyPostForm = (e) => {
    e.preventDefault();
    setShowReplyForm(false);
    setPostReply(false);
  };

  const submitQuoteForm = (e) => {
    e.preventDefault();
    setShowForm(false);
    setQuoteForm(false);
  };

  const submitQuotePostForm = (e) => {
    e.preventDefault();
    setShowForm(false);
    setQuotePostForm(false);
  };

  function goBackHandler() {
    navigate(`/forum/forums/${topic.catId._id}`);
  }
  //passing data from child to parent
  const alertSuccess = (msg) => {
    setAlertMessage({ type: "success", message: msg });
    setTimeout(function () {
      setAlertMessage({});
    }, 1000);
  };

  //Passing data from child to parent
  const alertFailure = (msg) => {
    setAlertMessage({ type: "danger", message: msg });
    setTimeout(function () {
      setAlertMessage({});
    }, 1000);
  };

  const loadPage = async () => {
    const p = await getPosts();

    const filteredPosts = p.data
      .filter((e) => e.topicId?._id === topicId)
      .map((item) => {
        return { ...item, narrative: item.narrative };
      });
    setReplies(filteredPosts);

    const { data } = await getTopic(topicId);

    setTopic(data);
    setTopicNarrative(data.narrative);
  };
  //post a reply
  const submitReply = (e, idx) => {
    setReplyForm({ id: idx, state: false });
    setEditForm({ id: idx, state: false });
    e.preventDefault();
  };

  useEffect(() => {
    loadPage();
  }, []);

  // main topic reply
  const handleReply = (e) => {
    e.preventDefault();
    setTopicReply(true);
  };

  const handleQuote = (text) => {
    console.log("quote");
    setQuoteComment(`> "\n${text}\n> "`)
    setQuoteForm(true);
  };
  const handleQuotePost = (e, idx, text) => {
    e.preventDefault();
    console.log("here meryem");
    setQuoteCommentForReply(`> "\n${text}\n> "`)
    setQuotePostForm({ id: idx, state: true });
  };

  const editReply = (e, idx) => {
    setEditForm({ id: idx, state: true });
  };

  const addPostReply = (e, idx) => {
    setPostReply({ id: idx, state: true });
  };

  const handleEditPost = (e) => {
    e.preventDefault();

    setEditPost(true);
    setEditForm(false);
    setShowForm(false);
  };

  const handleDelete = async (event, id) => {
    event.preventDefault();
    await deleteTopic(id);
    const myPosts = await getPosts();
    let filteredPosts = myPosts.data.filter((e) => e.topicId._id === id);
    filteredPosts.map(async (e) => {
      await deletePost(e._id);
    });
    navigate(-1);
  };

  const [nestedComments, setNestedComments] = useState([]);

  const stateRef = useRef();
  stateRef.current = nestedComments;

  const deleteReply = async (e, id) => {
    e.preventDefault();
    try {
      const comments = await getPosts();
      for (let j = 0; j < comments.data.length; j++) {
        const promise1 = Promise.resolve(
          getParent(comments.data[j], comments.data[j], id)
        );
        promise1.then(async (value) => {
          if (value !== null) {
            await deletePost(value._id);
          }
        });
        if (j == comments.data.length - 1) {
          await deletePost(id);
          loadPage();
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getParent = async (c, comment, id) => {
    if (comment.parentId === id) {
      return c;
    } else {
      if (!comment.parentId) {
        return null;
      } else {
        const p = await getPost(comment.parentId);
        return getParent(c, p.data, id);
      }
    }
  };

  const quoteArray = (narrative) => {
    const matches = narrative.match(/^(.*?)<p>/);

    if (matches && matches[1]) {
      const firstQuotes = matches[1].match(/"/g);

      if (firstQuotes) {
        return firstQuotes.map((quote, index) => {
          const spaces = " ".repeat(index); // Generate spaces based on the loop index
          return (
            <div key={index}>
              {spaces}
              {quote}
            </div>
          );
        });
      }
    }
    return null;
  };

  const replaceTheFirstQuote = (narrative) => {
    return [narrative.replace(/^(.*?)<p>/, "")] || [];
  };

  const openImageViewer = (imageUrl) => {
    setSelectedImage(imageUrl);
    setImageViewerOpen(true);
  };

  const closeImageViewer = () => {
    setSelectedImage("");
    setImageViewerOpen(false);
  };

  return (
    <Box mt={15} mb={15} className="container p-0 px-md-2">
      <div className="col-lg-12 bg-white col-12 py-2">
        <div className="col-lg-10 col-sm-12 col-12">
          {/* go back button */}
          <div
            style={{ justifyContent: "space-between", alignItems: "center" }}
            className="row mt-2"
          >
            <div className="d-flex align-items-center">
              <button
                onClick={goBackHandler}
                className="btn btn-secondary mr-2 ml-3"
              >
                Go Back
              </button>
              <p>{topic?.catId?.name}</p>
            </div>
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                underline="hover"
                className="linkStyle"
                onClick={() => navigate(`/forum`)}
              >
                <Typography color="text.primary" und>
                  Forum
                </Typography>
              </Link>
              <Link
                underline="hover"
                className="linkStyle"
                onClick={() => navigate(`/forum/${topic.catId._id}`)}
              >
                <Typography color="text.primary" und>
                  {topic?.catId?.name}
                </Typography>
              </Link>
              <Link
                underline="hover"
                className="linkStyle"
                onClick={() => navigate(`/forum/topic/${topic._id}`)}
              >
                <Typography color="text.primary" und>
                  {topic?.title}
                </Typography>
              </Link>
            </Breadcrumbs>
          </div>

          {topic._id && (
            <div className="">
              <div
                className="card shadow-none bg-white  p-0 "
                style={{ border: "none" }}
              >
                <div className="card-body text-dark">
                  <div className="mt-2">
                    {/* Avatar and email */}
                    <div className="media mb-4">
                      <img
                        src={`${topic?.user?.imageSrc}`}
                        className="rounded-circle mr-3 mail-img "
                        alt="media image"
                        width="70"
                        height="70"
                      />
                      <div className="media-body">
                        <h8 className="">
                          {topic?.user?.contactName.first +
                            " " +
                            topic?.user?.contactName.last}
                        </h8>{" "}
                        <br />
                        <div className="">
                          <i className="mdi mdi-clock mr-1 align-center"></i>
                          <small className="">
                            {moment(topic.createdOn).format("lll")}
                          </small>
                        </div>
                        {/* {topic.narrative} */}
                        <MyEditor
                          initialContent={topic?.narrative}
                          readOnly={true}
                        />
                        <div>
                          {/* <ImageCarousel
                              images={topic.attachments}
                              apiUrl={apiUrl}
                            /> */}

                          {/* Image Viewer */}
                          {isImageViewerOpen && (
                            <ImageViewer
                              imageUrl={selectedImage}
                              onClose={closeImageViewer}
                              isPopupOpen={isImageViewerOpen}
                            />
                          )}
                        </div>
                        {/* <div
                            className="topicTexts mt-2"
                            dangerouslySetInnerHTML={{
                              __html: replaceTheFirstQuote(
                                ReactHtmlParser(topic.narrative)[0]
                              ),
                            }}
                          /> */}
                      </div>
                    </div>
                    {/* <!-- media --> */}

                    {/* body */}
                    <div>
                      {" "}
                      {editPost &&
                        <div className="mb-3">
                          <EditPost
                            type={props.page}
                            submitForm={submitForm}
                            Post={topic}
                            topicNarrative={topicNarrative}
                            loadPage={loadPage}
                          />
                        </div>}
                      {topicReply && 
                      <div className="mb-3">
                        <ReplyTopic
                          reply="topic"
                          type={props.page}
                          submitReplyForm={submitReplyForm}
                          Post={topic}
                          loadPage={loadPage}
                        />
                      </div>}

                      {quoteForm ? (
                        // for quoting
                        <div>
                          <QuoteForm
                            message={quoteComment}
                            name={topic.title}
                            type={props.page}
                            submitForm={submitQuoteForm}
                            Post={topic}
                            quote="topic"
                            loadPage={loadPage}
                            alertSuccess={alertSuccess}
                            alertFailure={alertFailure}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="row bg-light px-3 py-3 border-bottom justify-content-end">
                    <div>
                      <div class="btn-group">
                        {" "}
                        <>
                          <div className="comment-reply d-flex justify-content-end align-items-center">
                            <Box>
                              <span style={{ marginRight: ".5rem" }}>
                                <FormatQuoteIcon
                                  className="internalTopic_Quote"
                                  onClick={() => handleQuote(topic.narrative)}
                                />
                              </span>
                              <span style={{ marginRight: ".5rem" }}>
                                <FavoriteBorderIcon className="internalTopic_Like" />
                              </span>
                              <span style={{ marginRight: ".5rem" }}>
                                <AttachmentIcon className="internalTopicd_Attachment" />
                              </span>
                              <span style={{ marginRight: ".5rem" }}>
                                <BookmarkBorderIcon className="internalTopic_Bookmark" />
                              </span>
                              <span style={{ marginRight: ".5rem" }}>
                                <ReplyIcon
                                  className="internalTopic_Reply"
                                  onClick={handleReply}
                                />
                              </span>
                              <span style={{ marginRight: ".5rem" }}>
                                <EditIcon
                                  className="internalTopic_Edit"
                                  onClick={handleEditPost}
                                />
                              </span>

                              <span style={{ marginRight: ".5rem" }}>
                                <PanToolIcon className="internalTopic_PanTool" />
                              </span>
                              <span style={{ marginRight: ".5rem" }}>
                                <DeleteIcon
                                  className="internalTopic_delete"
                                  onClick={(e) => handleDelete(e, topic._id)}
                                />
                              </span>
                              <span style={{ marginRight: ".5rem" }}>
                                <LockIcon className="internalTopic_Lock" />
                              </span>
                            </Box>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* End Body */}

        {/* Body  for replies*/}
        <div className="col-lg-10 ">
          <div className="ml-1 ml-md-4">
            <div
              className="card shadow-none bg-white "
              style={{ border: "none" }}
            >
              {replies.length !== 0
                ? replies.map((reply, idx) => (
                  // better ui
                  <div className="card-body text-dark">
                    {/* Avatar and email */}
                    <div className="media mb-4">
                      <img
                        src={`${reply?.user?.imageSrc}`}
                        className="rounded-circle mr-3 mail-img "
                        alt="media image"
                        width="70"
                        height="70"
                      />
                      <div className="media-body">
                        <h8 className="">
                          {reply?.user?.contactName.first +
                            " " +
                            reply?.user?.contactName.last}
                        </h8>{" "}
                        <br />
                        <div className="">
                          <i className="mdi mdi-clock mr-1 align-center"></i>
                          <small className="">
                            {moment(reply.createdOn).format("lll")}
                          </small>
                        </div>
                        <MyEditor 
                          initialContent={reply.narrative}
                          readOnly={true}
                        />
                        {/* <div
                          className="topicTexts mt-2"
                          dangerouslySetInnerHTML={{
                            __html: reply.narrative,
                          }}
                        /> */}
                      </div>
                    </div>
                    {/* <ImageCarousel
                          images={reply.attachments}
                          apiUrl={apiUrl}
                        /> */}
                    {/* body */}
                    {editForm.id == idx && editForm.state ? (
                      <>
                        <EditReplyForm
                          type={props.page}
                          submitReply={submitReply}
                          idx={idx}
                          reply={reply}
                          loadPage={loadPage}
                        />
                      </>
                    ) : (
                      <div
                        className="topicTexts mt-2"
                        dangerouslySetInnerHTML={{
                          __html: reply.message,
                        }}
                      />
                    )}
                    {postReply.id == idx && postReply.state ? (
                      <div className="mb-3">
                        <ReplyTopic
                          submitReplyForm={submitReplyPostForm}
                          type={props.page}
                          idx={idx}
                          Post={reply}
                          loadPage={loadPage}
                        />
                      </div>
                    ) : (
                      <div>
                        <div
                          className="topicTexts mt-2"
                          dangerouslySetInnerHTML={{
                            __html: topic.message,
                          }}
                        />
                      </div>
                    )}
                    {quotePostForm.id == idx && quotePostForm.state ? (
                      // for quoting
                      <div>
                        <QuoteForm
                          message={quoteCommentForReply}
                          idx={idx}
                          type={props.page}
                          name={
                            reply?.user?.contactName.first +
                            " " +
                            reply?.user?.contactName.last
                          }
                          submitForm={submitQuotePostForm}
                          Post={reply}
                          loadPage={loadPage}
                          alertSuccess={alertSuccess}
                          alertFailure={alertFailure}
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    <div class="col-lg-12">
                      <div class="row bg-light px-3 py-3  justify-content-end mt-3 mb-3">
                        {" "}
                        <div className="comment-reply d-flex justify-content-end align-items-center">
                          <Box>
                            <span style={{ marginRight: ".5rem" }}>
                              <FormatQuoteIcon
                                id={reply.userId}
                                className="internalTopic_Quote"
                                onClick={(e) => handleQuotePost(e, idx, reply.narrative)}
                              />
                            </span>
                            <span style={{ marginRight: ".5rem" }}>
                              <FavoriteBorderIcon />
                            </span>
                            <span style={{ marginRight: ".5rem" }}>
                              <AttachmentIcon className="internalTopic_Attachment" />
                            </span>
                            <span style={{ marginRight: ".5rem" }}>
                              <BookmarkBorderIcon className="internalTopic_Bookmark" />
                            </span>
                            <span style={{ marginRight: ".5rem" }}>
                              <ReplyIcon
                                id={reply.userId}
                                onClick={(e) => addPostReply(e, idx)}
                              />
                            </span>
                            <span style={{ marginRight: ".5rem" }}>
                              <EditIcon
                                id={reply.userId}
                                className="internalTopic_Reply"
                                onClick={(e) => editReply(e, idx)}
                              />
                            </span>

                            <span style={{ marginRight: ".5rem" }}>
                              <PanToolIcon className="internalTopic_PanTool" />
                            </span>
                            <span style={{ marginRight: ".5rem" }}>
                              <DeleteIcon
                                className="internalTopic_delete"
                                id={reply.userId}
                                onClick={(e) => deleteReply(e, reply._id)}
                              />
                            </span>
                            <span style={{ marginRight: ".5rem" }}>
                              <LockIcon className="internalTopic_Lock" />
                            </span>
                          </Box>
                        </div>{" "}
                      </div>
                    </div>
                    <hr />
                    {/* better ui  end*/}
                  </div>
                ))
                : ""}
            </div>
          </div>
        </div>
        {/* End Body for replies*/}
      </div>
    </Box>
  );
}
export default TopicDetail;
